module.exports = __webpack_public_path__ + "img/home_auth2.d2d69df3.png";